// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@conklin/XDL/Utilities";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

sortSelectStyles.select = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            &&& {
                width: 317px;
                ${xScreen("lte", "md")} {
                    width: 100%;
                    max-width: 100%;
                }
            }
        `,
        formInputWrapper: css`
            &&& {
                flex-grow: 1;
                width: 100%;
                max-width: 100%;
            }
        `,
    },
};
